module.exports = __webpack_public_path__ + "static/img/icon2.4f9c0e87.svg";